
(() => {
  const initProduct = (root = document) => {
    root.querySelectorAll('[data-bkf-product-section]').forEach((section) => {
      if (section.dataset.bkfInitialized === 'true') return;
      section.dataset.bkfInitialized = 'true';

      const select = section.querySelector('[data-bkf-variant-select]');
      const price = section.querySelector('[data-bkf-price]');
      const button = section.querySelector('[data-bkf-buy-button]');
      const message = section.querySelector('[data-bkf-variant-message]');
      const mainImage = section.querySelector('[data-bkf-main-image]');
      const defaultCta = section.dataset.bkfCta || 'Lägg i varukorgen';

      const applyVariant = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        const hasSelection = Boolean(option && option.value);
        const available = hasSelection && option.dataset.available === 'true';

        if (!hasSelection) {
          if (button) {
            button.disabled = true;
            button.textContent = 'Välj licens / alternativ';
          }
          if (message) {
            message.textContent = 'Välj ett alternativ innan du fortsätter.';
            message.classList.remove('is-error');
          }
          return;
        }

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (button) {
          button.disabled = !available;
          button.textContent = available ? defaultCta : 'Inte tillgänglig just nu';
        }

        if (message) {
          message.textContent = available ? '' : 'Det valda alternativet är inte tillgängligt just nu.';
          message.classList.toggle('is-error', !available);
        }

        if (mainImage && option.dataset.image) {
          mainImage.src = option.dataset.image;
          if (option.dataset.imageAlt) mainImage.alt = option.dataset.imageAlt;
        }

        if (window.history && window.history.replaceState) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', option.value);
            window.history.replaceState({}, '', url.toString());
          } catch (_) {}
        }
      };

      if (select) {
        select.addEventListener('change', applyVariant);
        applyVariant();
      }

      section.querySelectorAll('[data-bkf-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!mainImage || !thumb.dataset.image) return;
          mainImage.src = thumb.dataset.image;
          if (thumb.dataset.imageAlt) mainImage.alt = thumb.dataset.imageAlt;
          section.querySelectorAll('.bkf-product__thumb').forEach((wrap) => wrap.classList.remove('is-active'));
          thumb.closest('.bkf-product__thumb')?.classList.add('is-active');
        });
      });
    });
  };

  const initMenus = (root = document) => {
    root.querySelectorAll('.bk-header__menu').forEach((details) => {
      if (details.dataset.bkInitialized === 'true') return;
      details.dataset.bkInitialized = 'true';

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          details.removeAttribute('open');
          details.querySelector('summary')?.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (details.open && !details.contains(event.target)) {
          details.removeAttribute('open');
        }
      });
    });
  };

  const init = (root = document) => {
    initProduct(root);
    initMenus(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  const initV5Filters=(root=document)=>{
    root.querySelectorAll('[data-bkv5-resource-hub]').forEach((hub)=>{
      if(hub.dataset.v5Ready==='1')return;
      hub.dataset.v5Ready='1';
      const buttons=[...hub.querySelectorAll('[data-bkv5-filter]')];
      const cards=[...hub.querySelectorAll('[data-bkv5-resource-item]')];
      const status=hub.querySelector('[data-bkv5-resource-status]');
      const apply=(filter)=>{
        let visible=0;
        cards.forEach((card)=>{
          const kind=(card.dataset.kind||'').toLowerCase();
          const access=(card.dataset.access||'').toLowerCase();
          let show=true;
          if(filter==='free')show=access==='free';
          if(filter==='paid')show=access==='paid';
          if(filter==='material')show=kind==='material'||kind==='paket';
          if(filter==='course')show=kind==='kurs';
          if(filter==='package')show=kind==='paket';
          card.hidden=!show;if(show)visible++;
        });
        buttons.forEach((b)=>{const active=b.dataset.bkv5Filter===filter;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',active?'true':'false')});
        if(status)status.textContent=visible===1?'1 resurs visas':`${visible} resurser visas`;
      };
      buttons.forEach((b)=>b.addEventListener('click',()=>apply(b.dataset.bkv5Filter||'all')));
      apply('all');
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initV5Filters(document));else initV5Filters(document);
  document.addEventListener('shopify:section:load',(e)=>initV5Filters(e.target));
})();
